// src/pages/RedInstitucional.jsx
import React, { useState, useEffect } from "react";
import { Image, Spinner } from "react-bootstrap";
import { Card, CardGroup, Container, Modal, ListGroup } from "react-bootstrap";

import Cooperativas from "../components/cooperativas";
import NavbarFacach from "../components/NavbarFacach";
import FooterFacach from "../components/FooterFacach";
import SocialBar from "../components/SocialBar";

import { useSiteSettings } from '../hooks/useSiteSettings';
import fallbackBanner from '../assets/imagen.jpg';

import "../components/redinstituto.css";

import chc       from "../assets/chc.png";
import cnmch     from "../assets/fotos/CONAMUCOOPH.png";
import conajoven from "../assets/conajoven.png";
import colac     from "../assets/colac.png";
import aci       from "../assets/aci.png";
import dgrv      from "../assets/dgrv.png";

const API_URL = "https://facach.coop.hn/api";
const CMS_URL = "https://facach.coop.hn";

const buildImgUrl = (path) => {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  return `${CMS_URL}${path}`;
};

// ─── Fallbacks estáticos ──────────────────────────────────────────────────────
const ORGANISMOS_NACIONALES = [
  { id: "chc",      img: chc,      title: "Confederación Hondureña de Cooperativas (CHC)",                    info: { resumen: "Organismo de integración nacional que promueve y representa el movimiento cooperativo en Honduras.",                         sedes: [], web: "", redes: {} } },
  { id: "cnmch",    img: cnmch,    title: "Consejo Nacional de la Mujer Cooperativista de Honduras",          info: { resumen: "Órgano nacional que impulsa la participación y liderazgo de la mujer en el sector cooperativo.",                         sedes: [], web: "", redes: {} } },
  { id: "conajoven",img: conajoven,title: "Consejo Nacional de la Juventud Cooperativista de Honduras",       info: { resumen: "Consejo dedicado a la formación, participación y representación de la juventud cooperativista.",                          sedes: [], web: "", redes: {} } },
];

const ORGANISMOS_INTERNACIONALES = [
  { id: "dgrv",  img: dgrv,  title: "DGRV – Confederación Alemana de Cooperativas",                          info: { resumen: "Organismo internacional que promueve el desarrollo del cooperativismo a nivel global.",                                     sedes: [], web: "", redes: {} } },
  { id: "colac", img: colac, title: "COLAC – Confederación Latinoamericana de Cooperativas de Ahorro y Crédito", info: { resumen: "Entidad que integra y fortalece el sistema cooperativo de ahorro y crédito en América Latina.",                      sedes: [], web: "", redes: {} } },
  { id: "aci",   img: aci,   title: "ACI – Alianza Cooperativa Internacional",                                info: { resumen: "Organización global que representa y sirve a cooperativas en todo el mundo.",                                            sedes: [], web: "", redes: {} } },
];

// ─── OrgCard clickeable ───────────────────────────────────────────────────────
function OrgCard({ item, onOpen }) {
  const imgSrc = item.img || buildImgUrl(item.logo_url) || buildImgUrl(item.logo_path);
  return (
    <Card className="org-card org-card-clickable"
      role="button" tabIndex={0}
      onClick={() => onOpen(item)}
      onKeyDown={e => e.key === "Enter" && onOpen(item)}
      aria-label={`Ver información de ${item.title || item.name}`}
    >
      <Card.Img variant="top" src={imgSrc} alt={item.title || item.name}
        className="org-card-img" onError={e => { e.target.style.display = "none"; }} />
      <Card.Body className="org-card-body">
        <Card.Title className="org-card-title">{item.title || item.name}</Card.Title>
      </Card.Body>
    </Card>
  );
}

// ─── OrgCardStatic no clickeable ─────────────────────────────────────────────
function OrgCardStatic({ item }) {
  const imgSrc = item.img || buildImgUrl(item.logo_url);
  return (
    <Card className="org-card">
      <Card.Img variant="top" src={imgSrc} alt={item.title || item.name}
        className="org-card-img" onError={e => { e.target.style.display = "none"; }} />
      <Card.Body className="org-card-body">
        <Card.Title className="org-card-title">{item.title || item.name}</Card.Title>
      </Card.Body>
    </Card>
  );
}

// ─── InfoModal ────────────────────────────────────────────────────────────────
function InfoModal({ show, onHide, item }) {
  const info   = item?.info || {};
  const sedes  = info?.sedes || [];
  const imgSrc = item?.img || buildImgUrl(item?.logo_url) || buildImgUrl(item?.logo_path);
  const web    = info?.web || item?.website_url || "";
  const redes  = info?.redes || {};

  return (
    <Modal show={show} onHide={onHide} centered size="lg"
      dialogClassName="facach-modal" contentClassName="facach-modal-content"
      backdropClassName="facach-modal-backdrop">
      <div className="facach-modal-hero"
        style={{ backgroundImage: imgSrc ? `url(${imgSrc})` : "none" }}>
        <div className="facach-modal-hero-overlay" />
        <div className="facach-modal-hero-content">
          <div className="facach-chip">Empresa Relacionada</div>
          <h4 className="facach-modal-title">{item?.title || item?.name || "Información"}</h4>
        </div>
        <button type="button" className="btn facach-close" aria-label="Cerrar" onClick={onHide}>✕</button>
      </div>

      <div className="facach-modal-body">
        {(info?.resumen || item?.description) ? (
          <p className="facach-parrafo">{info?.resumen || item?.description}</p>
        ) : (
          <p className="facach-parrafo muted">Información en actualización. Pronto agregaremos más detalles.</p>
        )}

        <div className="facach-divider"><span>SEDES Y HORARIOS</span></div>

        {sedes.length > 0 ? (
          <ListGroup variant="flush" className="sedes-list">
            {sedes.map((s, i) => (
              <ListGroup.Item key={i} className="px-0">
                <div className="sede-item">
                  <div className="sede-titulo"><strong>{s.nombre || "Sede"}</strong></div>
                  {s.direccion && <div className="sede-linea"><span className="sede-label">Dirección:</span> {s.direccion}</div>}
                  {s.telefono  && <div className="sede-linea"><span className="sede-label">Teléfono:</span> <a href={`tel:${s.telefono.replace(/[^0-9+]/g, "")}`}>{s.telefono}</a></div>}
                  {s.correo    && <div className="sede-linea"><span className="sede-label">Correo:</span> <a href={`mailto:${s.correo}`}>{s.correo}</a></div>}
                  {Array.isArray(s.horarios) && s.horarios.length > 0 ? (
                    <div className="sede-linea">
                      <span className="sede-label">Horarios:</span>
                      <ul className="mb-0 horarios-list">
                        {s.horarios.map((h, idx) => (
                          <li key={idx}><span className="dias">{h.dias}</span>: <span className="horas">{h.horas}</span></li>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    <div className="sede-linea text-muted">Horarios: No disponibles.</div>
                  )}
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        ) : (
          <div className="text-muted">No hay sedes disponibles aún.</div>
        )}

        {(web || redes?.facebook || redes?.linkedin) && (
          <>
            <div className="facach-divider soft"><span>ENLACES</span></div>
            <div className="d-flex gap-2 flex-wrap">
              {web             && <a href={web}             target="_blank" rel="noreferrer" className="btn btn-outline-primary btn-sm">Sitio web</a>}
              {redes?.facebook && <a href={redes.facebook}  target="_blank" rel="noreferrer" className="btn btn-outline-secondary btn-sm">Facebook</a>}
              {redes?.linkedin && <a href={redes.linkedin}  target="_blank" rel="noreferrer" className="btn btn-outline-secondary btn-sm">LinkedIn</a>}
            </div>
          </>
        )}
      </div>
    </Modal>
  );
}

// ─── Página principal ─────────────────────────────────────────────────────────
export default function RedInstitucional() {
  const { settings }   = useSiteSettings();
  const bannerSrc      = settings.banner_image
    ? `https://facach.coop.hn${settings.banner_image}`
    : fallbackBanner;

  const [empresas, setEmpresas]             = useState([]);
  const [loadingEmpresas, setLoadingEmp]    = useState(true);
  const [organismos, setOrganismos]         = useState({});
  const [loadingOrganismos, setLoadingOrg]  = useState(true);
  const [showModal, setShowModal]           = useState(false);
  const [selectedItem, setSelectedItem]     = useState(null);

  // Fetch empresas relacionadas
  useEffect(() => {
    const fetch_ = async () => {
      try {
        const res  = await fetch(`${API_URL}/related-companies`);
        const json = await res.json();
        if (json.ok) setEmpresas(json.data);
      } catch (err) {
        console.error("Error cargando empresas relacionadas:", err.message);
      } finally { setLoadingEmp(false); }
    };
    fetch_();
  }, []);

  // Fetch organismos de integración
  useEffect(() => {
    const fetch_ = async () => {
      try {
        const res  = await fetch(`${API_URL}/integrations`);
        const json = await res.json();
        if (json.ok && Object.keys(json.grouped || {}).length > 0) {
          setOrganismos(json.grouped);
        }
      } catch (err) {
        console.error("Error cargando organismos:", err.message);
      } finally { setLoadingOrg(false); }
    };
    fetch_();
  }, []);

  const openModal  = (item) => { setSelectedItem(item); setShowModal(true); };
  const closeModal = ()     => { setShowModal(false); setSelectedItem(null); };

  const hayOrganismosDinamicos = Object.keys(organismos).length > 0;

  return (
    <>
      <NavbarFacach />
      <div className="banner-wrapper">
        <Image src={bannerSrc} alt="Red Institucional - FACACH" fluid className="banner-image" />
        <div className="banner-overlay">
          <h1 className="banner-title">RED INSTITUCIONAL</h1>
        </div>
      </div>

      <div>
        {/* Cooperativas dinámicas */}
        <Cooperativas />

        {/* Empresas relacionadas */}
        <Container className="my-5">
          <h2 className="section-title">EMPRESAS RELACIONADAS</h2>
          {loadingEmpresas ? (
            <div className="text-center py-4">
              <Spinner animation="border" variant="primary" size="sm" />
            </div>
          ) : empresas.length > 0 ? (
            <CardGroup className="org-card-group">
              {empresas.map(item => <OrgCard key={item.id} item={item} onOpen={openModal} />)}
            </CardGroup>
          ) : (
            <p className="text-muted text-center py-3">No hay empresas registradas aún.</p>
          )}
        </Container>

        {/* Organismos de integración */}
        <Container className="my-5">
          <h2 className="section-title">ORGANISMOS DE INTEGRACIÓN</h2>

          {loadingOrganismos ? (
            <div className="text-center py-4">
              <Spinner animation="border" variant="primary" size="sm" />
            </div>
          ) : hayOrganismosDinamicos ? (
            // ── Dinámicos desde la BD ──
            Object.entries(organismos).map(([tipo, items]) => (
              <div key={tipo} className="mb-4">
                <h3 className="section-subtitle">{tipo}</h3>
                <CardGroup className="org-card-group">
                  {items.map(item => (
                    <OrgCardStatic key={item.id} item={{
                      id:          item.id,
                      title:       item.name,
                      img:         null,
                      logo_url:    item.logo_url,
                      website_url: item.website_url,
                    }} />
                  ))}
                </CardGroup>
              </div>
            ))
          ) : (
            // ── Fallback estático ──
            <>
              <h3 className="section-subtitle">Nacionales</h3>
              <CardGroup className="org-card-group">
                {ORGANISMOS_NACIONALES.map(item => <OrgCardStatic key={item.id} item={item} />)}
              </CardGroup>
              <h3 className="section-subtitle mt-4">Internacionales</h3>
              <CardGroup className="org-card-group">
                {ORGANISMOS_INTERNACIONALES.map(item => <OrgCardStatic key={item.id} item={item} />)}
              </CardGroup>
            </>
          )}
        </Container>

        <SocialBar position="right" top="35%" size={42} rounded={true} />
        <FooterFacach />
      </div>

      <InfoModal show={showModal} onHide={closeModal} item={selectedItem} />
    </>
  );
}